import React, { useEffect, useState } from 'react';
import styles from './Footer.module.scss';
import { ReactComponent as BackToTopIcon } from "../../../images/BackToTop.svg";
import cx from 'classnames';
import { getCurrentYear } from '../utils/date';
import { isNullOrUndefined } from '@microsoft/applicationinsights-core-js';
import { CommonApi } from "../../../services/Common";
import { isNullOrUndefinedOrEmptyString } from '../utils/util';

export interface ComponentProps {
  lmsApiError: boolean;
  lmsLink: any;
}

const scrollToTop = (e: any) => {
  e.preventDefault();
  window.scrollTo({ top: 0, behavior: "smooth" })
}

const Footer: React.FC<ComponentProps> = (props: { lmsLink: any, lmsApiError: boolean }) => {

  const [version, setVersion] = useState('');

  const openLmsUrl = (isTrainingLink: boolean) => {
    if (props.lmsApiError) {
      openBlankUrl(isTrainingLink);
    }
    else if (!isNullOrUndefined(props.lmsLink)) {
      let url = isTrainingLink ? props.lmsLink.trainingLink : props.lmsLink.releaseLink;
      if (!props.lmsApiError && url != null && url !== '') {
        window.open(url, '_blank');
      }
    }
    else {
      openBlankUrl(isTrainingLink);
    }
  }

  const openBlankUrl = (isTrainingLink: boolean) => {
    var newWin = window.open('', '_blank');
    var message = isTrainingLink ? 'Training manuals are currently unavailable. Please try again later. If the problem persists, please contact our Residential Support team.' : 'Release information is currently unavailable. Please try again later. If the problem persists, please contact our Residential Support team.';
    newWin?.alert(message);
  }

  useEffect(() => {
    const commonApi = new CommonApi();
    commonApi.getVersion()
      .then(result => {
        setVersion(result.version);
      })
      .catch(error => {
        setVersion('');
      })
  }, []);

  return (
    <div className={styles.topMargin}>
      <div role="navigation" className={styles.footerDock} >
        <div className={styles.footerDockButtonContainer}>
          <a onClick={scrollToTop} className={cx(styles.footerDockButton, styles.backToTop, styles.fadeIn)} href="#" aria-label="Top of main content">Top
            <span>
              <BackToTopIcon />
            </span>
          </a>
        </div>
      </div>

      <footer>
        <nav className={styles.footer} aria-label="Footer links">
          <div className={styles.footerContainer}>
            <section>
              <div className={styles.footerHeader}>
                Need help?
              </div>
              <div >
                {(!isNullOrUndefined(props.lmsLink) || props.lmsApiError) && (
                  <>
                    <a onClick={() => openLmsUrl(true)}><span className={styles.paddingRight20}> Training manuals</span></a>
                    <a onClick={() => openLmsUrl(false)}><span> Release information</span></a>
                  </>
                )}
              </div>
              <div><hr className={styles.separator}></hr>
                <span className={cx(styles.footerHeader, styles.paddingRight20)}>&copy; {getCurrentYear()} Telstra Health</span>
                <span>{!isNullOrUndefinedOrEmptyString(version) ? "Version " + version : ""}</span>
              </div>
            </section>
          </div>
        </nav>
      </footer>
    </div>
  )
};

export default Footer;